import React, { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'

let overpanelRoot = document.getElementById('overpanel-root')
if (!overpanelRoot) {
  overpanelRoot = document.createElement('div')
  overpanelRoot.id = 'overpanel-root'
  overpanelRoot.style.position = 'static'
  document.body.appendChild(overpanelRoot)
}

interface PortalProps {
  children: React.ReactNode
}

const Portal: React.FC<PortalProps> = ({ children }) => {
  const domRef = useRef<HTMLDivElement>(document.createElement('div'))

  useEffect(() => {
    const domElement = domRef.current
    overpanelRoot!.appendChild(domElement)

    return () => {
      overpanelRoot!.removeChild(domElement)
    }
  }, [])

  return ReactDOM.createPortal(children, domRef.current)
}

export default Portal
